// extracted by mini-css-extract-plugin
module.exports = {"form":"FreeQuoteForm_form__q1Jf0","input":"FreeQuoteForm_input__UBZVd","label":"FreeQuoteForm_label___J4p5"};